<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap>
      <v-flex xs3>
        <v-card flat>
          <v-card-text>
            <div class="primary--text">Billing Details</div>
            <div v-if="transaction.billing_name">{{ transaction.billing_name }}</div>
            <div v-if="transaction.billing_address"> {{ transaction.billing_address }}</div>
            <div v-if="transaction.billing_city || transaction.billing_state || transaction.billing_postal_code">
              {{ transaction.billing_city }},
              {{ transaction.billing_state }}
              {{ transaction.billing_postal_code }}
            </div>
            <div v-if="transaction.billing_country && transaction.billing_country !== 'USA'"> {{ transaction.billing_country }}</div>
            <div v-if="transaction.billing_phone">{{ transaction.billing_phone }}</div>
            <div v-if="transaction.billing_email">{{ transaction.billing_email }}</div>
            <div v-if="transaction.billing_ip_address">{{ transaction.billing_ip_address }}</div>
          </v-card-text>
        </v-card>

        <v-card flat>
          <v-card-text>
            <div><span class="primary--text">{{ transaction.payment_type ? transaction.payment_type.toUpperCase() : '' }}</span> ************{{ transaction.last_four }}</div>
            <div v-if="transaction.request_type === 'authorize' || transaction.request_type === 'sale'"><span class="primary--text">Auth No</span> {{ transaction.auth_code }}</div>
          </v-card-text>
        </v-card>

        <!--
        <v-card flat>
          <v-card-text>
            <div><span>{{ transaction.response_code === '000' ? 'Approved' : 'Declined' }}</span> ({{ transaction.response_code }})</div>
            <div v-if="transaction.response_code !== '000'">{{ transaction.response_text }}</div>
            <div>Created {{ datetime(transaction.created) }}</div>
            <div>Created By {{transaction.user_name ? transaction.user_name : 'API'}}</div>
            <div v-if="transaction.updated">Updated {{ datetime(transaction.updated) }}</div>
            <div v-if="transaction.settled">Settled {{ datetime(transaction.settled) }}</div>
            <div v-if="transaction.voided">Voided {{ datetime(transaction.voided) }}</div>
            <div v-if="transaction.refunded">Refunded {{ datetime(transaction.refunded) }}</div>
            <div v-if="transaction.settled">Settled {{ datetime(transaction.settled) }}</div>
          </v-card-text>
        </v-card>
        -->

        <v-card flat>
          <v-card-text>
          </v-card-text>
        </v-card>

        <v-card flat>
          <v-card-text>
          </v-card-text>
        </v-card>

      </v-flex>

      <v-flex xs9>
        <v-card flat>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs3 pr-2 text-xs-right class="primary--text">ID</v-flex>
              <v-flex xs9>{{transaction.tracking_id}}</v-flex>
              <v-flex xs6></v-flex>
              <v-flex xs3 pr-2 text-xs-right class="primary--text">Recurring</v-flex>
              <v-flex xs3>
                <span class="text-capitalize">{{ transaction.is_recurring ? (transaction.recurring_type + ' / ' + transaction.recurring_status) : 'No' }}</span>
              </v-flex>

              <v-flex xs3 pr-2 text-xs-right class="primary--text">Type</v-flex>
              <v-flex xs3>
                {{ transaction.request_type }}
                <v-chip x-small class="ma-0 pa-0" v-if="transaction.custom && transaction.custom.hasOwnProperty('is_health_rewards_card') && transaction.custom.is_health_rewards_card">HSA</v-chip>
              </v-flex>

              <template v-if="(transaction.modify_recurring_type && transaction.modify_recurring_type !== 'none') || transaction.is_recurring">
                <v-flex xs3 pr-2 text-xs-right class="primary--text">Recurring Start</v-flex>
                <v-flex xs3>
                  <span v-if="transaction.parent_modify_recurring_start">{{ dateUtc(transaction.parent_modify_recurring_start) }}</span>
                  <span v-else-if="transaction.modify_recurring_start">{{ dateUtc(transaction.modify_recurring_start) }}</span>
                  <span v-else-if="transaction.parent_recurring_start">{{ dateUtc(transaction.parent_recurring_start) }}</span>
                  <span v-else>{{ transaction.recurring_start ? dateUtc(transaction.recurring_start) : '-' }}</span>
                </v-flex>
              </template>
              <template v-else-if="transaction.future_post">
                <v-flex xs3 pr-2 text-xs-right class="primary--text">Post Date</v-flex>
                <v-flex xs3>{{dateUtc(transaction.future_post)}}</v-flex>
              </template>
              <template v-else><v-flex xs6></v-flex></template>

              <v-flex xs3 pr-2 text-xs-right class="primary--text">Account</v-flex>
              <v-flex xs3>{{transaction.account_name}}</v-flex>

              <template v-if="(transaction.modify_recurring_type && transaction.modify_recurring_type !== 'none') || transaction.is_recurring">
                <v-flex xs3 pr-2 text-xs-right class="primary--text">Recurring End</v-flex>
                <v-flex xs3>
                  <span v-if="transaction.parent_modify_recurring_end">{{(transaction.parent_modify_recurring_end === '2099-12-31T00:00:00.000Z') ? 'ongoing' : dateUtc(transaction.parent_modify_recurring_end)}}</span>
                  <span v-else-if="transaction.modify_recurring_end">{{(transaction.modify_recurring_end === '2099-12-31T00:00:00.000Z') ? 'ongoing' : dateUtc(transaction.modify_recurring_end)}}</span>
                  <span v-else-if="transaction.parent_recurring_end">{{(transaction.parent_recurring_end === '2099-12-31T00:00:00.000Z') ? 'ongoing' : dateUtc(transaction.parent_recurring_end)}}</span>
                  <span v-else-if="!transaction.recurring_end && transaction.is_recurring">ongoing</span>
                  <span v-else>{{(!transaction.recurring_end) ? '-' : (transaction.recurring_end === '2099-12-31T00:00:00.000Z') ? 'ongoing' : dateUtc(transaction.recurring_end)}}</span>
                </v-flex>
              </template>
              <template v-else><v-flex xs6></v-flex></template>

              <v-flex xs3 pr-2 text-xs-right class="primary--text">Terminal</v-flex>
              <v-flex xs3>{{transaction.terminal_code}}</v-flex>
              <v-flex xs3 pr-2 text-xs-right class="primary--text">Tokenized</v-flex>
              <v-flex xs3>{{transaction.token_id ? 'Yes' : 'No'}}</v-flex>
              <v-flex v-if="hasPermission('can_use_hpp')" xs3 pr-2 text-xs-right class="primary--text">Hosted Payment</v-flex>
              <v-flex v-if="hasPermission('can_use_hpp')" xs3>{{transaction.transactions_source_id === 6 ? 'Yes' : 'No'}}</v-flex>

              <v-flex xs3 pr-2 text-xs-right class="primary--text">Reference ID</v-flex>
              <v-flex xs3 class="text-wrap">{{transaction.reference_number}}</v-flex>
              <v-flex xs3 pr-2 text-xs-right class="primary--text">Response Code</v-flex>
              <v-flex xs3>{{transaction.response_code}}</v-flex>

              <v-flex xs3 pr-2 text-xs-right class="primary--text">Total Amount</v-flex>
              <v-flex xs3 v-if="transaction.request_type === 'credit' || transaction.request_type === 'void' || transaction.request_type === 'achcredit' || transaction.request_type === 'achvoid'">({{money(transaction.total_amount / 100)}})</v-flex>
              <v-flex xs3 v-else>{{money(transaction.total_amount / 100)}}</v-flex>

              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.is_fee_waived">Waived</v-flex>
              <v-flex xs3 v-if="transaction.is_fee_waived">{{transaction.fee_waived_amount ? money(transaction.fee_waived_amount / 100) : ''}}</v-flex>

              <v-flex xs3 pr-2 text-xs-right class="primary--text">Response Text</v-flex>
              <v-flex xs3>
                {{transaction.response_text}}
                <template v-if="transaction.auth_response && transaction.response_code !== '000' && transaction.response_text !== transaction.auth_response && transaction.payment_type !== 'ach'">
                  : {{transaction.auth_response}}
                </template>
              </v-flex>

              <template v-if="transaction.request_type === 'sale' && transaction.is_cashdiscount && !transaction.is_fee_waived">
              <v-flex xs3 pr-2 text-xs-right class="primary--text">Fee Amount</v-flex>
              <v-flex xs3>{{money(transaction.fee_amount / 100)}}</v-flex>
              </template>

              <template v-if="transaction.payment_type !== 'ach'">
              <v-flex xs3 pr-2 text-xs-right class="primary--text">CVV / AVS</v-flex>
              <v-flex xs3>{{transaction.cvv2_response}} / {{transaction.avs_response}}</v-flex>
              </template>

              <v-flex xs3 pr-2 text-xs-right class="primary--text">Created</v-flex>
              <v-flex xs3>{{datetime(transaction.created)}}</v-flex>
              <v-flex xs3 pr-2 text-xs-right class="primary--text">Updated</v-flex>
              <v-flex xs3>{{transaction.updated ? datetime(transaction.updated) : ''}}</v-flex>

              <v-flex xs3 pr-2 text-xs-right class="primary--text">Created By</v-flex>
              <v-flex xs3>{{transaction.user_name ? transaction.user_name : (transaction.api_method === 'batch' ? 'batch' : '')}}</v-flex>

              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.request_type === 'ach'">ACH Status</v-flex>
              <v-flex xs3 v-if="transaction.request_type === 'ach'">{{achStatusOptions[transaction.ach_status_id]}}</v-flex>

              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.request_type === 'ach' && transaction.ach_rejected">ACH Rejected</v-flex>
              <v-flex xs3 v-if="transaction.request_type === 'ach' && transaction.ach_rejected">{{transaction.ach_rejected ? datetime(transaction.ach_rejected) : ''}}</v-flex>

              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.request_type === 'ach' && transaction.account_permissions.hasOwnProperty('can_use_nacha_authorization') && transaction.account_permissions.can_use_nacha_authorization">ACH Auth</v-flex>
              <v-flex xs3 v-if="transaction.request_type === 'ach' && transaction.account_permissions.hasOwnProperty('can_use_nacha_authorization') && transaction.account_permissions.can_use_nacha_authorization">{{transaction.ach_is_authorized ? 'Yes' : 'No'}}</v-flex>

              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.modify_created">Modified</v-flex>
              <v-flex xs3 v-if="transaction.modify_created">{{datetime(transaction.modify_created)}}</v-flex>

              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.captured_transaction_id">Captured</v-flex>
              <v-flex xs3 v-if="transaction.captured_transaction_id">{{datetime(transaction.captured)}}</v-flex>
              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.settled">Settled</v-flex>
              <v-flex xs3 v-if="transaction.settled">{{datetime(transaction.settled)}}</v-flex>
              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.voided_transaction_id">Voided</v-flex>
              <v-flex xs3 v-if="transaction.voided_transaction_id">{{datetime(transaction.voided)}}</v-flex>
              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.refunded">Refunded</v-flex>
              <v-flex xs3 v-if="transaction.refunded">{{datetime(transaction.refunded)}}</v-flex>
              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.refunded || credited">Refund Total</v-flex>
              <v-flex xs3 v-if="transaction.refunded || credited">({{ money(credited / 100)}})</v-flex>

              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.customer_po">Customer PO</v-flex>
              <v-flex xs3 v-if="transaction.customer_po">{{transaction.customer_po}}</v-flex>
              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.custom_field_1">Custom 1</v-flex>
              <v-flex xs3 v-if="transaction.custom_field_1" class="text-wrap">{{transaction.custom_field_1}}</v-flex>
              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.custom_field_2">Custom 2</v-flex>
              <v-flex xs3 v-if="transaction.custom_field_2" class="text-wrap">{{transaction.custom_field_2}}</v-flex>
              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.custom_field_3">Custom 3</v-flex>
              <v-flex xs3 v-if="transaction.custom_field_3" class="text-wrap">{{transaction.custom_field_3}}</v-flex>

              <v-flex xs3 pr-2 text-xs-right class="primary--text"></v-flex>
              <v-flex xs3></v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs3 pr-2 text-xs-right class="primary--text" v-if="transaction.notes">Notes</v-flex>
              <v-flex xs9 v-if="transaction.notes" class="text-wrap">{{transaction.notes}}</v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-divider class="primary"></v-divider>

    <v-layout row wrap>
      <v-spacer></v-spacer>
      <v-btn v-if="transaction.transaction_group_custom_tracking_id" :to="{ name: 'PlanManage', query: { id: transaction.transaction_group_custom_tracking_id }}">Payment Plan</v-btn>

      <template v-if="(hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions')) && transaction.request_type === 'ach' && transaction.response_code === '000' && !transaction.voided && !transaction.ach_is_authorized && !transaction.parent_transaction_id && transaction.account_permissions.hasOwnProperty('can_use_nacha_authorization')">
        <v-btn @click="authorize">Authorization Received</v-btn>
        <v-btn @click="printAuthorization">Print ACH Auth</v-btn>
        <v-btn @click="emailAuthorization" v-if="transaction.billing_email">Email ACH Auth</v-btn>
      </template>

      <template v-if="(hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions')) && transaction.request_type === 'ach' && transaction.response_code === '000' && !transaction.voided && transaction.ach_is_authorized && !transaction.parent_transaction_id && transaction.account_permissions.hasOwnProperty('can_use_nacha_authorization')">
        <v-btn @click="printAuthorization">Reprint ACH Auth</v-btn>
      </template>

      <template v-if="(hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions')) && transaction.request_type === 'ach' && !transaction.voided && transaction.ach_status_id === 2 && transaction.ach_is_authorized && !transaction.processor_transaction_id && transaction.processor_id !== 4">
        <v-btn @click="sendToProcessor">Send to Processor</v-btn>
      </template>

      <AchAuthPrint ref="achAuth" v-if="transaction && (hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions'))" :transaction="transaction" />
    </v-layout>
  </v-container>
</template>

<script>
import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

import AchAuthPrint from './AchAuthPrint.vue'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],
  components: {AchAuthPrint},

  data: function () {
    return {
      achStatusOptions: {
        1: 'Pending ACH authorization',
        2: 'Batched for processing',
        3: 'Pending bank approval',
        4: 'Approved',
        5: 'Declined'
      },

      enabled: false
    }
  },

  props: {
    transaction: Object
  },

  mounted () {},

  computed: {
    credited: function () {
      if (!this.transaction.hasOwnProperty('associatedTransactions') || this.transaction.associatedTransactions.length < 1) {
        return 0
      }

      let totalCredited = this.transaction.associatedTransactions.reduce((runningTotal, transaction) => {
        if ((transaction.request_type === 'credit' || transaction.request_type === 'achcredit') && transaction.response_code === '000' && transaction.parent_transaction_id === this.transaction.id && !transaction.voided) {
          return runningTotal + transaction.total_amount
        }
        return runningTotal
      }, 0)

      return totalCredited
    }
  },

  methods: {
    async authorize () {
      try {
        if (!this.transaction || !this.transaction.id) {
          throw new Error('Unable to identify transaction')
        }

        let options = {
          id: this.transaction.id,
          ach_is_authorized: true,
          ach_status_id: 2
        }

        let result = await this.api({
          method: 'put',
          url: `/transactions/${this.transaction.id}`,
          data: options
        })

        if (result.data && result.data.error === false) {
          // Bus.$emit('openModal', {status: 'success', message: 'Authorization accepted'})
          this.transaction.ach_is_authorized = true
          this.sendToProcessor()
          // Bus.$emit('optionsClose')
        } else {
          Bus.$emit('openModal', {status: 'error', message: 'Unexpected Error'})
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      }
    },

    printAuthorization () {
      this.$refs.achAuth.print()
    },

    async emailAuthorization () {
      try {
        if (!this.transaction || !this.transaction.id) {
          throw new Error('Unable to identify transaction')
        }

        let result = await this.api({
          method: 'get',
          url: `/transactions/${this.transaction.id}/send_authorization_email`
        })

        if (result.data && result.data.error === false) {
          Bus.$emit('openModal', {status: 'success', message: 'Email sent'})
        } else {
          Bus.$emit('openModal', {status: 'error', message: 'Unexpected Error'})
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      }
    },

    async sendToProcessor () {
      try {
        if (!this.transaction || !this.transaction.id) {
          throw new Error('Unable to identify transaction')
        }

        Bus.$emit('openWaitModal')
        let result = await this.api({
          method: 'post',
          url: `/terminal/submit`,
          data: {
            tracking_id: this.transaction.tracking_id
          }
        })
        Bus.$emit('closeWaitModal')

        if (result.data && result.data.response.ResponseText === 'CHECK ACCEPTED') {
          Bus.$emit('openModal', {status: 'success', message: 'Successfully sent to processor'})
          this.transaction.ach_is_authorized = true
          Bus.$emit('optionsClose')
        } else {
          let error = result.data.response.ResponseText
          if (result.data.response.ErrMsg) {
            error += ': ' + result.data.response.ErrMsg
          }
          Bus.$emit('openModal', {status: 'error', message: error})
        }
      } catch (err) {
        Bus.$emit('closeWaitModal')
        Bus.$emit('openModal', {status: 'error', message: err})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/Details.vue